import { createSlice } from "@reduxjs/toolkit";
import {getAllTransactionListOfWallet,getMinimumWalletAmount,getHoldMoneyInfo } from "./ThunkActions";
import { iWalletState, REDUCER_NAME } from "./Types";

const initialState: iWalletState = {
  isLoading: false,
  errorMessage: null,
  walletTransactionList:[],
  mimimumWalletAmount:null,
  holdMoneyInfo:null,
};

export const walletSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetWalletState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      
      //get all transaction list of wallet
     
      .addCase(getAllTransactionListOfWallet.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllTransactionListOfWallet.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          const walletData = payload.data.data;
          state.walletTransactionList = Array.isArray(walletData)
            ? walletData
            : walletData?.transactions || [];
          state.isLoading = false;
        }
      })
      .addCase(getAllTransactionListOfWallet.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })

      //get winimum wallet balance
      .addCase(getMinimumWalletAmount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMinimumWalletAmount.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.mimimumWalletAmount = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getMinimumWalletAmount.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })

      //get info about hold money
      .addCase(getHoldMoneyInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHoldMoneyInfo.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.holdMoneyInfo = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getHoldMoneyInfo.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })
  },
});

export const { resetWalletState } = walletSlice.actions;
export default walletSlice.reducer;
  
